// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";

function getWeeklyEarningDetails(weeklyEarnings, msisdn) {
  return List.map((function (record) {
                return {
                        workUnit: record.workUnit,
                        totalEarnings: record.totalEarnings,
                        totalCashSettlement: record.totalCashSettlement,
                        totalWalletSettlement: record.totalWalletSettlement,
                        date: record.date,
                        msisdn: msisdn
                      };
              }), weeklyEarnings.weeklyEarnings);
}

function getViewModel(weeklyEarningsDetails) {
  return {
          weeklyEarnings: getWeeklyEarningDetails(weeklyEarningsDetails, weeklyEarningsDetails.msisdn),
          msisdn: weeklyEarningsDetails.msisdn
        };
}

var WeeklyEarningsDetailsVMMapper = {
  getViewModel: getViewModel
};

export {
  WeeklyEarningsDetailsVMMapper ,
  
}
/* No side effect */
